// src/pages/Dashboard/Orders.jsx
import React, { useState, useEffect } from 'react';
import OrdersTable from '../../components/Layout/Dashboard/Orders/Orders';

const Orders = () => {
  const [isDark, setIsDark] = useState(false);


  return <OrdersTable  />;
};

export default Orders;